import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchComponent } from '../../../base/search/search.component';
import { ProductSearchResult } from '../../../../models/net/result/product-search-result';
import { ProductEnvelope } from '../../../../models/net/envelope/product-envelope';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { AppService } from '../../../../services/app.service';
import { SessionService } from '../../../../services/session/session.service';
import { ProductService } from '../../../../services/products/product.service';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { ProductSearchRequest } from '../../../../models/net/request/product-search-request';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css', '../../../../app.component.css']
})

export class ProductsComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "Name", "Description", "CreatedOnUTC", "Delete"];
    public override searchResult: ProductSearchResult[] = [];
    public searchRequestEnvelopes: ProductEnvelope[] = [];
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: ProductService) {

        super(appService, sessionService, itemService, "product", "Product");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.ProductSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();

        this.isSearchMarqueeDisabled = false;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: ProductSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var resourceSearchRequest: ProductSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (resourceSearchRequest) {

                this.runSearch(resourceSearchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: ProductSearchResult) => i.ProductId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: ProductSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
